import React, { useState, useEffect, useRef } from 'react';
import { 
  Container,
  Row,
  Col,
  FormGroup,
  Input,
  Button,
  Label,
  CustomInput,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';

import AssociationFields from '../vente/bien/VAssociationFields';
import { constants } from '../../types/constants';
import { PRIVILEGE } from '../../types/privileges'
import { connect } from 'react-redux';
import { editVente } from '../../flux/actions/venteActions';
import { askDoa } from '../../flux/actions/doaActions';
import { getDivisionByBienId } from '../../flux/actions/divisionActions';
import { IAskDoaModal, IAuthReduxProps, ITarget } from '../../types/interfaces';
import Select from 'react-select';
import LoadingPage from '../../pages/loading';
import Loading from '../Loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faBuilding, faHashtag, faHouseDamage, faLayerGroup, faMoneyBill, faMoneyBillAlt, faRulerCombined, faThLarge, faCompass, faMap, faQuestionCircle, faSquare, faCheckSquare, faSearch, faBookmark, faMapMarkerAlt, faSignature, faFolder, faFileInvoice, faReceipt, faFileContract, faFilePdf, faSync, faCloudUploadAlt, faHandRock, faTimes, faSpinner, faCheckCircle, faInfoCircle, faPercent, faPen, faCalendarAlt, faFileImage, faBookOpen, faPrint, faFileDownload, faPencilRuler, faLockOpen, faCommentsDollar, faSyncAlt } from '@fortawesome/free-solid-svg-icons'
import { useHistory, useLocation } from 'react-router-dom';
import { useAlert } from "react-alert";
import ReactTooltip from 'react-tooltip';
import moment from "moment";
import PDFLink, { PreviewBase64, printBase64, downloadBase64, instantUploadToFTP, printBuffer } from '../pdf/PDFLink';

import DatePicker from "reactstrap-date-picker";
import DivisionModal from './DivisionModal';

const AskDoaModal = ({ 
  modal,
  setModal,
  modalData,
  askDoa,
  auth
 }: IAskDoaModal) => {
  const alert = useAlert();
  const history = useHistory();
  
  const [disableSubmit, setDisableSubmitDoa] = useState(false);
  const [reEnable, setReEnableDoa] = useState(false);
  
  const [newPriceValue, setNewPriceValue] = useState(0);
  const [newPriceTotalValue, setNewPriceTotalValue] = useState(true);
  const [newPriceFlag, setNewPriceFlag] = useState(false);
  const newPriceRef = useRef<HTMLInputElement>(document.createElement("input"));
  const [commentValue, setCommentValue] = useState('');
  
  const [selectedFloor, setSelectedFloor] = useState<any>();
  const [selectedDivisionType, setSelectedDivisionType] = useState<any>();
  const [selectedDivisionPercent, setSelectedDivisionPercent] = useState<any>();
  const [etageValue, setEtageValue] = useState<any>('');
  const [typeValue, setTypeValue] = useState<any>('');
  const [positionValue, setPositionValue] = useState('');
  const [percentValue, setPercentValue] = useState(0);
  const [superficieValue, setSuperficieValue] = useState(0);
  const [prixpartValue, setPrixpartValue] = useState(0);
  const [partCommentValue, setPartCommentValue] = useState('');
  const [association, setAssociation] = useState<any>(undefined);

  const [divisionModal, setDivisionModal] = useState<any>();
  const [division, setDivision] = useState<any>();
  const [divisionLoading, setDivisionLoading] = useState(false);
  const [divisionFlag, setDivisionFlag] = useState(false);
  
  const handleToggleOA = () => setModal(!modal);

  const newPriceChangeHandler = (e/*: ITarget*/) => {
    const doubleValue = e.target.value ? e.target.value.toString().replace(",", ".") : 0,
      splits = doubleValue.toString().split(".");
    if(!isNaN(doubleValue) && +doubleValue >= 0){
      const res = splits.length === 2 && splits[1] !== "" ? Number((+doubleValue).toFixed(2)) : doubleValue;
      setNewPriceValue(res);
    }
    else if(e.target.value === "")
      setNewPriceValue(0)
  };

  const changeNewPriceTotal = (e: boolean) => {
    if(e){
      if(!newPriceTotalValue){
        setNewPriceTotalValue(true);
        setNewPriceValue(Number(newPriceValue) * ((modalData?.contrat ? modalData?.contrat.SUPERFICIE : modalData?.SUPERFICIE) ? Number(modalData?.contrat ? modalData?.contrat.SUPERFICIE : modalData.SUPERFICIE) : 1))
      }
    }
    else{
      if(newPriceTotalValue){
        setNewPriceTotalValue(false);
        setNewPriceValue(Number(newPriceValue) / ((modalData?.contrat ? modalData?.contrat.SUPERFICIE : modalData?.SUPERFICIE) ? Number(modalData?.contrat ? modalData?.contrat.SUPERFICIE : modalData.SUPERFICIE) : 1))
      }
    }
  }

  const commentChangeHandler = (e: ITarget) => setCommentValue(e.target.value);

  const focusHandler = (e) => {
    if(e.target.value == "0")
      e.target.select();
  };

  useEffect(() => {
    if(!newPriceFlag)
      setNewPriceFlag(true)
    else if(newPriceValue === 0 && newPriceRef?.current)
      newPriceRef.current.select()
  }, [newPriceValue]);

  const modalOpenedHandle = () => {
    setNewPriceTotalValue(true);
    setDivision(undefined)
    if(modalData?.id){
      setNewPriceValue(Number(modalData.contrat ? modalData.contrat.PRIX_NET : modalData.PRIX_VENTE) + (modalData.IDPROJET === 5 ? (Number(modalData.contrat ? modalData.contrat.SUPERFICIE : modalData.SUPERFICIE) * 500) : 0));
      
      setDivisionFlag(true)
      setDivisionLoading(true)
      getDivisionByBienId(modalData.id)
      .then(e => {
        setDivision(e)
      })
      .finally(() => setDivisionLoading(false))
    }
  };

  const modalClosedHandle = () => {
    setDivisionFlag(false)
    setNewPriceValue(0);
    setCommentValue('');
    setEtageValue('');
    setTypeValue('');
    setPositionValue('');
    setPercentValue(0);
    setSuperficieValue(0);
    setPrixpartValue(0);
    if(reEnable){
      setDisableSubmitDoa(false);
      setReEnableDoa(false);
    }
  };

  useEffect(() => {
    setAssociation({
      selectedFloor,
      selectedDivisionType,
      selectedDivisionPercent,
      ETAGE: selectedFloor?.floor,
      TYPE: typeValue ? typeValue["isNew"] ? typeValue["name"] : typeValue.value : undefined,
      POSITION: positionValue,
      POURCENTAGE: selectedDivisionPercent?.percent,
      SUPERFICIE: superficieValue,
      PRIX_VENTE: prixpartValue,
      OBSERVATION: partCommentValue,
    })
  }, [selectedFloor, selectedDivisionType, selectedDivisionPercent, typeValue, positionValue, percentValue, superficieValue, prixpartValue]);

  // useEffect(() => {
  //   setAssociation({
  //     ETAGE: etageValue?.value,
  //     TYPE: typeValue ? typeValue["isNew"] ? typeValue["name"] : typeValue.value : undefined,
  //     POSITION: positionValue,
  //     POURCENTAGE: percentValue,
  //     SUPERFICIE: superficieValue,
  //     PRIX_VENTE: prixpartValue
  //   })
  // }, [etageValue, typeValue, positionValue, percentValue, superficieValue, prixpartValue]);

  const doaCallback = (success) => {
    if(success){
      setReEnableDoa(true);
      setModal(false);
      alert.success(`Demande envoyée avec succès`, {timeout: 10000});
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmitDoa(false);
  }

  const askDoaHandle = () => {
    if(!modalData)
      return
    if(modalData?.contrat?.TYPE_VENTE === "UNIQUE"){
      if(!association){
        alert.error("Veuillez saisir les informations de l'association");
        return
      }
      if(association.ETAGE === undefined){
        alert.error("Veuillez sélectionner un étage");
        return
      }
      if(association.TYPE === undefined){
        alert.error("Veuillez sélectionner le type de l'association");
        return
      }
      if(!association.POURCENTAGE){
        alert.error("Veuillez saisir un pourcentage");
        return
      }
      if(!association.PRIX_VENTE){
        alert.error("Veuillez saisir le prix de vente de l'association");
        return
      }
    }
    setDisableSubmitDoa(true);
    askDoa(modalData["id"], (modalData?.contrat ? modalData?.contrat.SUPERFICIE : modalData?.SUPERFICIE) || 0, (modalData.contrat ? modalData.contrat.PRIX_NET : modalData.PRIX_VENTE) || 0, newPriceTotalValue ? Number(newPriceValue) : (Number(newPriceValue) * ((modalData?.contrat ? modalData?.contrat.SUPERFICIE : modalData?.SUPERFICIE) ? Number(modalData?.contrat ? modalData?.contrat.SUPERFICIE : modalData.SUPERFICIE) : 1)), modalData?.contrat?.TYPE_VENTE === "UNIQUE" ? modalData.contrat.id : undefined, modalData?.contrat?.TYPE_VENTE === "UNIQUE" ? association : undefined, commentValue, auth?.user && auth?.user.id ? auth?.user.id : undefined, auth?.user && auth?.user.username ? auth?.user.username : undefined, doaCallback);
  }

  return <><Modal isOpen={modal} toggle={handleToggleOA} onOpened={modalOpenedHandle} onClosed={modalClosedHandle} className="modal-dialog-extra-large">
    <ModalHeader toggle={handleToggleOA}><FontAwesomeIcon icon={faLockOpen} />&nbsp;&nbsp;Demande d'ouverture en association</ModalHeader>
    <ModalBody>
        <Container className="linesConfirmationContainer">
          <Row className="mb-2">
            Voulez-vous vraiment envoyer une demande pour ouvrir le bien&nbsp;<b>{modalData ? modalData["DESIGNATION"] : ""}</b>&nbsp;en association ?
          </Row>
          <Row>
            <Col xs="12">
              <FontAwesomeIcon icon={faRulerCombined} />&nbsp;Superficie : <span style={{fontWeight: 600}}>{(modalData?.contrat ? modalData?.contrat.SUPERFICIE : modalData?.SUPERFICIE) ? ((modalData?.contrat ? modalData?.contrat.SUPERFICIE : modalData?.SUPERFICIE) + "m²") : "-"}</span>
            </Col>
          </Row>
          <Row>
            <Col xs="12">
              <FontAwesomeIcon icon={faMoneyBill} />&nbsp;Ancien prix {modalData?.contrat ? "de vente" : "du bien"} : <span style={{fontWeight: 600}}>{((modalData?.contrat ? modalData?.contrat.PRIX_NET : modalData?.PRIX_VENTE) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh"}{(modalData?.contrat ? modalData?.contrat.PRIX_M : modalData?.PRIX_M) ? (" (" + ((modalData?.contrat ? modalData?.contrat.PRIX_M : modalData?.PRIX_M) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh/m²)") : ""}</span>
            </Col>
          </Row>
          <Row>
            <Col xs="12">
              <FormGroup>
                <Label for="new_price"><FontAwesomeIcon icon={faCommentsDollar} />&nbsp;Nouveau prix de l'association</Label>
                <span style={{display: "inline-block", whiteSpace: "nowrap"}}>
                  <span className={`bienCardRadio${!newPriceTotalValue ? " selectedBCRadioWarning" : ""}`} onClick={() => changeNewPriceTotal(false)}><FontAwesomeIcon icon={!newPriceTotalValue ? faCheckSquare : faSquare} />&nbsp;du m²</span>
                  <span className={`bienCardRadio${newPriceTotalValue ? " selectedBCRadioWarning" : ""}`} onClick={() => changeNewPriceTotal(true)}><FontAwesomeIcon icon={newPriceTotalValue ? faCheckSquare : faSquare} />&nbsp;du total</span>
                </span>
                &nbsp;&nbsp;<FontAwesomeIcon icon={faSyncAlt} style={{cursor: "pointer", fontSize: "small"}} onClick={() => {setNewPriceTotalValue(true); setNewPriceValue((modalData.contrat ? modalData.contrat.PRIX_NET : modalData.PRIX_VENTE) || 0);}} data-tip data-for="resetNewPricetooltip" />
                <ReactTooltip effect="solid" id="resetNewPricetooltip" type={"dark"}>
                  Réinitialiser le prix
                </ReactTooltip>
                <InputGroup className="quantityInputGroup">
                  <Input id="new_price" type="number" pattern="[0-9]*" disabled invalid={newPriceTotalValue ? (Number(modalData?.contrat ? modalData.contrat.PRIX_NET : modalData?.PRIX_VENTE) > Number(newPriceValue) || Number(newPriceValue) >= Number(modalData?.contrat ? modalData.contrat.PRIX_NET : modalData?.PRIX_VENTE) * 10) : (Number(modalData?.contrat ? modalData.contrat.PRIX_M : modalData?.PRIX_M) > Number(newPriceValue) || Number(newPriceValue) >= Number(modalData?.contrat ? modalData.contrat.PRIX_M : modalData?.PRIX_M) * 10)} placeholder="Nouveau prix de l'association..." innerRef={newPriceRef} value={Number(newPriceValue).toString()} onFocus={focusHandler} onChange={newPriceChangeHandler} className="form-control" />
                  <InputGroupAddon addonType="append">
                    <InputGroupText>DH</InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </FormGroup>
            </Col>
          </Row>
          <Row className="mt-1">
            <Col xs="12">
              <Input id="comment" type="textarea" placeholder="Commentaire..." value={commentValue} onChange={commentChangeHandler} />
            </Col>
          </Row>
          {/* <Row className="justify-content-center">
            <Button
              className="btn btn-info linesConfirmationBtn linesDeleteBtn"
              onClick={() => setDivisionModal(true)}
              disabled={!divisionFlag || !!divisionLoading || !!division || !auth?.user?.privileges?.includes(PRIVILEGE.ADD_DIVISION)}
              ><FontAwesomeIcon icon={false ? faSpinner : faLockOpen} className={false ? "spinner" : ""} />&nbsp;&nbsp;{!divisionFlag || divisionLoading ? "..." : !division ? "Proposer une répartition" : division.approved === 1 ? "Répartition validée" : "Répartition en attente de validation"}</Button>
          </Row> */}
          {modalData?.contrat?.TYPE_VENTE === "UNIQUE" && <Row className="mt-4">
            <Col xs="12">
              <AssociationFields isDoa={true} selectedBien={modalData} selectedFloor={selectedFloor} setSelectedFloor={setSelectedFloor} selectedDivisionType={selectedDivisionType} setSelectedDivisionType={setSelectedDivisionType} selectedDivisionPercent={selectedDivisionPercent} setSelectedDivisionPercent={setSelectedDivisionPercent} etageValue={etageValue} setEtageValue={setEtageValue} typeValue={typeValue} setTypeValue={setTypeValue} positionValue={positionValue} setPositionValue={setPositionValue} percentValue={percentValue} setPercentValue={setPercentValue} superficieValue={superficieValue} setSuperficieValue={setSuperficieValue} prixpartValue={prixpartValue} setPrixpartValue={setPrixpartValue} commentValue={partCommentValue} setCommentValue={setPartCommentValue} />
            </Col>
          </Row>}
          <Row className="justify-content-center">
            <Button
              className="btn btn-warning linesConfirmationBtn linesDeleteBtn"
              onClick={askDoaHandle}
              disabled={disableSubmit || !divisionFlag || !!divisionLoading || !division || division.approved !== 1}
              ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faLockOpen} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Envoyer la demande d'ouverture en association</Button>
          </Row>
        </Container>
    </ModalBody>
  </Modal>

  <DivisionModal modal={divisionModal} setModal={setDivisionModal} bien={modalData} addCallback={e => setDivision(e)} />
  </>
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { editVente, askDoa })(AskDoaModal);
